export enum GroupsEnum {
  GestoresMaster = 1,
  AdmFiduci = 2,
  Custodia = 3,
  LiquidacaoOpen = 4,
  MiddleAdmFiduci = 5,
  AdministradorSistema = 6,
  GestoresBoleta = 7,
  CustodiaRV = 8,
  Cutoff = 9,
  Recebiveis = 10,
  Integrator = 11,
  ExternalClearing = 12,
  Distribution = 13,
  LiquidacaoTEF = 14,
  Passive = 15,
  CriadoresUploadTransferencia = 16,
  AprovadoresUploadTransferencia = 17,
  VisualizadoresDeBoletas = 18,
  DistribuidorMaster = 30,
  DistribuidorBoleta = 31,
  Controladoria = 35,
}
